import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//component ui:
import DatePicker from '../../utils/DatePicker';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        marginLeft: 25,
        marginTop: 35,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 20px',
        marginBottom: 20,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class EditItvMaquina extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.itv.id ? this.props.itv.id : uuidv4(),
            fechaCaducidad: this.props.itv.fechaCaducidad
                ? this.props.itv.fechaCaducidad.slice(0, 10)
                : new Date().toJSON().slice(0, 10),
            maquinaId: this.props.itv.maquinaId
                ? this.props.itv.maquinaId
                : this.props.maquinaId,
            maquina: this.props.itv.maquina ? this.props.itv.maquina : null,
        };
    }

    //textfield
    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        {/* <TextField
                            id={'fechaCaducidad'}
                            label={'Fecha Caducidad'}
                            placeholder={'Fecha Caducidad'}
                            type="date2"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            className={classes.textField}
                            margin="normal"
                            autoFocus
                            value={this.state.fechaCaducidad}
                            onChange={(event) => this.handleValueChange(event, 'fechaCaducidad')}
                        /> */}
                        <DatePicker
                            label={'Fecha Caducidad'}
                            value={this.state.fechaCaducidad}
                            className={classes.textField}
                            onChange={event => {
                                if (event && !isNaN(event)) {
                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                    this.handleValueChangeDate(
                                        d.toISOString().slice(0, 10),
                                        'fechaCaducidad',
                                    )
                                }
                            }}
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="secondary"
                        onClick={() => this.props.hideDialog()}
                    >
                        Cerrar
                    </Button>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            const itv = {
                                id: this.state.id,
                                fechaCaducidad: this.state.fechaCaducidad,
                                maquinaId: this.state.maquinaId,
                                maquina: this.state.maquina,
                            };

                            if (this.props.checkItv(itv)) {
                                this.props.okHandler(itv);
                                this.props.hideDialog();
                            }
                        }}
                    >
                        Guardar
                    </Button>
                </div>
            </div>
        );
    }
}

EditItvMaquina.propTypes = {
    itv: PropTypes.object.isRequired,
    maquinaId: PropTypes.number.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkItv: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditItvMaquina);
